/**
 * Secure Storage Utility
 * Uses localStorage for persistent login — user stays logged in until they press Logout.
 * clearAll() is called only on explicit logout.
 */

const TOKEN_KEY = 'token';
const USER_KEY = 'user';
const VENDOR_TOKEN_KEY = 'vendor_token';

export const secureStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },
  removeToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  getUser: () => {
    const raw = localStorage.getItem(USER_KEY);
    try { return raw ? JSON.parse(raw) : null; } catch { return null; }
  },
  setUser: (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  removeUser: () => {
    localStorage.removeItem(USER_KEY);
  },

  getVendorToken: () => localStorage.getItem(VENDOR_TOKEN_KEY),
  setVendorToken: (token) => {
    localStorage.setItem(VENDOR_TOKEN_KEY, token);
  },
  removeVendorToken: () => {
    localStorage.removeItem(VENDOR_TOKEN_KEY);
  },

  clearAll: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(VENDOR_TOKEN_KEY);
  }
};
